import { render, staticRenderFns } from "./CheckoutLayout.vue?vue&type=template&id=a31bf4be&"
import script from "./CheckoutLayout.vue?vue&type=script&lang=js&"
export * from "./CheckoutLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a31bf4be')) {
      api.createRecord('a31bf4be', component.options)
    } else {
      api.reload('a31bf4be', component.options)
    }
    module.hot.accept("./CheckoutLayout.vue?vue&type=template&id=a31bf4be&", function () {
      api.rerender('a31bf4be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/CheckoutLayout.vue"
export default component.exports